import './Features.css';
import { FaExchangeAlt, FaChartLine, FaBell } from 'react-icons/fa';

const Features = () => {
  const features = [
    {
      icon: <FaExchangeAlt />,
      title: "All-in-One Crypto Hub",
      description: "Tek platform üzerinden kripto varlıklarınızı yönetin, takip edin ve işlem yapın."
    },
    {
      icon: <FaChartLine />,
      title: "Gerçek Zamanlı Analizler",
      description: "En güncel fiyat grafikleri ve teknik analizlerle piyasayı takip edin."
    },
    {
      icon: <FaBell />,
      title: "Akıllı Bildirimler",
      description: "Önemli fiyat hareketleri ve fırsatlar için kişiselleştirilmiş uyarılar alın."
    },
  ];

  return (
    <section id="features" className="section features">
      <div className="container">
        <h2 className="section-title" data-aos="fade-up">
          Tüm İhtiyaçlarınız İçin <span className="gradient-text">Tek Platform</span>
        </h2>
        <p className="section-description" data-aos="fade-up" data-aos-delay="100">
          CTO ile kripto piyasalarını takip etmek, analiz etmek ve yönetmek hiç bu kadar kolay olmamıştı.
        </p>
        
        <div className="features-grid">
          {features.map((feature, index) => (
            <div 
              className="feature-item" 
              key={index}
              data-aos="fade-up" 
              data-aos-delay={100 + (index * 100)}
            >
              <div className="feature-icon">{feature.icon}</div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features; 